import http from './http.service';

class MediaService {
  upload(params) {
    const formData = new FormData();
    Object.keys(params)
      .forEach((key) => {
        formData.append(key, params[key]);
      });

    return http.post('media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((res) => res.data);
  }
}

export default new MediaService();
